
const messageFromGM = {
    title: "MESSAGE FROM THE GENERAL MANAGER",
    content: "After nearly ten years of precipitation and growth of the industry, our company has a strong R&D and manufacturing capacity and efficient detection means. At present, VIDEYA covers a full range of endodontic instruments: K/H/R files, Spreader/Plugger, Paste carriers, Barbed broaches, Gates drills/Pesso reamers, Fiber post drills."
};

export default {
    data() {
        return {
            messageFromGM
        }
    }
}
